import builder from '../builder';
import ViewOff from '../../streamline-icons/bold/view-off.svg';

export default builder('IconViewOffBold', ViewOff);
